const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { scrollAction } = require("./modules/scrollAction");

scrollmagic();
pageTop();
smooth();
scrollAction();
